// extracted by mini-css-extract-plugin
export default {"cursor":"style_cursor__TpyV8"};